import {
  faBuilding, faCheckCircle, faHome, faPlus, faTimesCircle
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import React, { Component } from 'react';
import CONSTANTS from '../../constants';
import OrderTypeHelper from '../../helpers/OrderTypeHelper';
import TimeHelper from '../../helpers/TimeHelper';
import LocationService from '../../services/LocationService';
import UserLocationService from '../../services/UserLocationService';
import AlertModal from './AlertModal';
import MapModal from './MapModal';
import OrderTime from './OrderTime';
import Outlets from './Outlets';
import SavedLocations from './SavedLocations';
import TimePickerModal from './TimePickerModal';

class OrderTypeDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...props.cartState,
      loaded: false
    };
  }

  checkDeliveryOutletError() {
    if (!this.state.delivery_location || !this.state.selectedOutlet || !this.state.selectedLocation)
      return;

    const outlet = LocationService.getDeliveryOutlet(
      this.state.delivery_location,
      this.props.outlets,
      this.state.selectedOutlet
    );
    if (!outlet || outlet.loc_id !== this.state.selectedOutlet.loc_id) {
      this.setState({ deliveryOutletError: true });
    } else {
      this.setState({ deliveryOutletError: false });
    }
  }

  async componentDidMount() {
    const savedLocations = await UserLocationService.getSavedLocations();
    const order_time =
      typeof this.state.order_time === 'string'
        ? new Date(this.state.order_time)
        : this.state.order_time;
    const selectedLocation = this.state.selectedLocation ?? savedLocations[0] ?? null;
    const delivery_location = selectedLocation
      ? [selectedLocation.latitude, selectedLocation.longitude].toString()
      : '';
    const delivery_address = selectedLocation ? selectedLocation.address : '';
    this.setState(
      {
        savedLocations,
        order_time,
        loaded: true,
        selectedLocation,
        delivery_location,
        delivery_address
      },
      () => {
        //this.props.updateState(JSON.parse(JSON.stringify(this.state)));
        if (this.props.isDelivery) {
          this.checkDeliveryOutletError();
        }
      }
    );
  }

  async componentDidUpdate(prevpros) {
    if (this.props.isLoggedIn !== prevpros.isLoggedIn) {
      const savedLocations = await UserLocationService.getSavedLocations();
      await this.setState({
        savedLocations,
        selectedLocation: this.props.cartState.selectedLocation
      });
    }
    const {
      props: { order_type_id }
    } = this;
    const {
      state: { savedLocations }
    } = this;
    const { order_type_id: oldType } = prevpros;
    if (order_type_id !== oldType) {
      const state = { order_type_id: this.props.order_type_id };
      if (!this.state.selectedLocation && savedLocations?.length > 0) {
        state.selectedLocation = this.state.savedLocations[0];
      }
      if (!this.state.selectedOutlet) {
        state.selectedOutlet = this.props.outlets[0];
      } else {
        let exist = false;
        for (let i = 0; i < this.props.outlets.length; i++) {
          if (this.props.outlets[i].loc_id === this.state.selectedOutlet.loc_id) {
            exist = true;
            break;
          }
        }
        if (!exist) {
          state.selectedOutlet = this.props.outlets[0];
        } else {
          state.selectedOutlet = this.state.selectedOutlet;
        }
      }

      state.showOutlets = false;
      state.showMapModal = false;
      state.showAlerModal = false;
      state.showTimePickerModal = false;
      this.setState(state, () => {
        this.checkDeliveryOutletError();
        this.props.updateState(this.state);
      });
    }
  }

  toggleMapModal() {
    this.setState(
      {
        showMapModal: !this.state.showMapModal
      },
      () => {
        this.props.updateState(JSON.parse(JSON.stringify(this.state)));
      }
    );
  }

  toggleAlertModal() {
    this.setState(
      {
        showAlerModal: !this.state.showAlerModal
      },
      () => {
        this.props.updateState(JSON.parse(JSON.stringify(this.state)));
      }
    );
  }

  toggleSelectOutlet() {
    this.setState(
      {
        showOutlets: !this.state.showOutlets
      },
      () => {
        this.props.updateState(JSON.parse(JSON.stringify(this.state)));
      }
    );
  }

  toggleSavedLocations() {
    this.setState(
      {
        showSavedLocations: !this.state.showSavedLocations
      },
      () => {
        this.props.updateState(JSON.parse(JSON.stringify(this.state)));
      }
    );
  }

  toggleTimePickerModal() {
    this.setState(
      {
        showTimePickerModal: !this.state.showTimePickerModal
      },
      () => {
        this.props.updateState(JSON.parse(JSON.stringify(this.state)));
      }
    );
  }

  onChange(event) {
    const target = event.target;
    this.setState({ [target.name]: target.value }, () => {
      this.props.updateState(JSON.parse(JSON.stringify(this.state)));
    });
  }

  onChangeOutlet(outlet, toggle = true) {
    this.setState({ selectedOutlet: outlet }, () => {
      this.props.updateState(JSON.parse(JSON.stringify(this.state)));
      this.checkDeliveryOutletError();
    });
    if (toggle) this.toggleSelectOutlet();
  }

  toggleIsPickUpNow() {
    this.setState(
      {
        isPickUpNow: !this.state.isPickUpNow
      },
      () => {
        this.props.updateState(JSON.parse(JSON.stringify(this.state)));
      }
    );
  }

  onNowSelect(value) {
    this.changeDate(value, new Date());
  }

  changeDate(orderDate, orderTime, suppressErrors = false) {
    this.onChange({ target: { suppressErrors, name: 'order_date', value: orderDate } });
    this.onChange({ target: { suppressErrors, name: 'order_time', value: orderTime } });
    this.onChange({ target: { suppressErrors, name: 'isPickUpNow', value: true } });
  }

  timeLabel() {
    let selectedTime = TimeHelper.getDateFromTimeOption(
      this.state.order_date,
      this.state.order_time
    );
    if (TimeHelper.differenceFromNow(selectedTime) < 60) return 'Now';
    return moment(selectedTime).format(CONSTANTS.DATE_TIMES.FORMAT.DISPLAY);
  }

  async updateSavedLocations(isClose, loc = null) {
    const savedLocations = await UserLocationService.getSavedLocations();
    await this.setState({ editLocation: '', savedLocations: savedLocations });
    const exist = await UserLocationService.checkIfSavedLocationExist(this.state.selectedLocation);
    if ((!this.state.selectedLocation || !exist) && this.state.savedLocations.length > 0) {
      const selectedLocation = this.state.savedLocations[0];
      const delivery_location = [selectedLocation.latitude, selectedLocation.longitude].toString();
      const delivery_address = selectedLocation.address;
      this.setState({ selectedLocation, delivery_location, delivery_address }, () => {
        this.props.updateState(JSON.parse(JSON.stringify(this.state)));
        this.checkDeliveryOutletError();
      });
    } else if (loc) {
      const selectedLocation = loc;
      const delivery_location = [selectedLocation.latitude, selectedLocation.longitude].toString();
      const delivery_address = selectedLocation.address;
      this.setState({ selectedLocation, delivery_location, delivery_address }, () => {
        this.props.updateState(JSON.parse(JSON.stringify(this.state)));
        this.checkDeliveryOutletError();
      });
    }
    if (isClose) {
      this.toggleMapModal();
    }
  }

  async onEditLocation(item, itemIndex) {
    this.setState({ itemIndex: itemIndex, editLocation: item }, this.toggleMapModal.bind(this));
  }

  async onNewLocation() {
    this.setState({ itemIndex: -1, editLocation: null }, this.toggleMapModal.bind(this));
  }

  async onDeleteLocation(item, itemIndex) {
    this.setState({ itemIndex: itemIndex });
    this.toggleAlertModal();
  }

  async deleteLocation() {
    await UserLocationService.deleteSavedLocations(this.state.itemIndex);
    this.updateSavedLocations(false);
    this.toggleAlertModal();
  }

  onLocationSelect(selectedLocation) {
    const delivery_location = [selectedLocation.latitude, selectedLocation.longitude].toString();
    const delivery_address = selectedLocation.address;
    this.setState({ selectedLocation, delivery_location, delivery_address }, () => {
      this.props.updateState(JSON.parse(JSON.stringify(this.state)));
      this.toggleSavedLocations();
      this.checkDeliveryOutletError();
    });
  }

  render() {
    const timeSettings = OrderTypeHelper.pickOrderTimeFor(
      this.props.location.orderTypes,
      this.props.order_type_id
    );
    const showLoginOption =
      !this.props.isLoggedIn &&
      (!this.state.savedLocations || this.state.savedLocations.length === 0);
    let grid_layout = localStorage.getItem('grid_layout');
    const card_outline = this.props.locationSettings.card_outline_enable === 1 ? 'card-outline-color' : '';
    if (grid_layout === 'old') {
      return (
        <>
          {this.state.loaded && this.state.showOutlets && (
            <MapModal
              toggleModal={this.toggleMapModal.bind(this)}
              showModal={this.state.showMapModal}
              name="Search Outlet"
              isTakeAway={true}
              data={this.props.outlets}
              selectedOutlet={this.state.selectedOutlet}
              locationSettings={this.props.locationSettings}
              onChangeOutlet={this.onChangeOutlet.bind(this)}
            />
          )}
          {this.state.loaded && this.props.isDelivery && !this.state.showOutlets && (
            <MapModal
              toggleModal={this.toggleMapModal.bind(this)}
              showModal={this.state.showMapModal}
              name="Add new location"
              itemIndex={this.state.itemIndex}
              editLocation={this.state.editLocation}
              selectedOutlet={this.state.selectedOutlet}
              data={this.props.outlets}
              locationSettings={this.props.locationSettings}
              updateSavedLocations={this.updateSavedLocations.bind(this)}
            />
          )}

          {this.state.loaded && (
            <AlertModal
              toggleModal={this.toggleAlertModal.bind(this)}
              showModal={this.state.showAlerModal}
              msg="Are you sure to delete this location?"
              deleteLocation={this.deleteLocation.bind(this)}
              locationSettings={this.props.locationSettings}
            />
          )}

          {this.state.loaded && (
            <TimePickerModal
              {...this.state}
              onChange={this.onChange.bind(this)}
              toggleModal={this.toggleTimePickerModal.bind(this)}
              showModal={this.state.showTimePickerModal}
              orderTypes={this.props.location.orderTypes}
              workingHours={this.state.selectedOutlet.workingHours}
              timeSettings={timeSettings}
              isDelivery={this.props.isDelivery}
              locationSettings={this.props.locationSettings}
            />
          )}
          <div className="ps-3 pe-3" id="order_time">
            <div className="time-field mb-2">
              <div className="f3 fw-bold mt-1">
                {((showLoginOption && this.props.isDelivery) ||
                  (this.state.savedLocations &&
                    this.state.savedLocations.length > 0 &&
                    this.props.isDelivery &&
                    !this.state.showOutlets)) && (
                    <span className="ps-2 fw-bold primary-font-color">
                      {this.state.showSavedLocations ? 'Saved Locations' : 'Selected Location'}
                    </span>
                  )}
                {((this.props.outlets && !this.props.isDelivery) ||
                  (this.state.showOutlets && !this.state.showSavedLocations)) && (
                    <span class="ps-2 primary-font-color" onClick={this.toggleSelectOutlet.bind(this)}>
                      Select Outlet
                    </span>
                  )}
                {!showLoginOption &&
                  this.props.isDelivery &&
                  !this.state.showSavedLocations &&
                  (!this.state.savedLocations || this.state.savedLocations.length === 0) && (
                    <span
                      className="ps-2 cursor primary-font-color"
                      onClick={this.onNewLocation.bind(this)}
                    >
                      <FontAwesomeIcon icon={faPlus} /> &nbsp;Add new Location
                    </span>
                  )}
              </div>
              <div className="mt-1 f3 d-flex flex-auto justify-content-between">
                {this.state.showOutlets &&
                  (!this.props.isDelivery || !this.state.showSavedLocations) && (
                    <>
                      <span
                        className="ps-2 cursor ml-1 branding-btn-color text-decoration-underline"
                        onClick={this.toggleMapModal.bind(this)}
                      >
                        Show Map
                      </span>
                      <span
                        className="ps-2 cursor branding-btn-color text-decoration-underline"
                        onClick={this.toggleSelectOutlet.bind(this)}
                      >
                        Back
                      </span>
                    </>
                  )}
                {!this.state.showOutlets && !this.props.isDelivery && (
                  <>
                    <div></div>
                    <button
                      className="btn btn-link p-0 highlight-color text-decoration-underline"
                      onClick={this.toggleSelectOutlet.bind(this)}
                    >
                      Change
                    </button>
                  </>
                )}
                {this.props.isDelivery &&
                  this.state.savedLocations &&
                  !this.state.showOutlets &&
                  !(
                    !showLoginOption &&
                    this.props.isDelivery &&
                    (!this.state.savedLocations || this.state.savedLocations.length === 0)
                  ) && (
                    <>
                      <div></div>
                      <button
                        className="btn btn-link p-0 branding-btn-color text-decoration-underline"
                        onClick={this.toggleSavedLocations.bind(this)}
                      >
                        {this.state.showSavedLocations ? 'Back' : 'Edit'}
                      </button>
                    </>
                  )}
              </div>
            </div>
          </div>
          {this.state.showOutlets && (
            <Outlets
              data={this.props.outlets}
              geoLocation={this.props.geoLocation}
              showOutlets={this.state.showOutlets}
              onChangeOutlet={this.onChangeOutlet.bind(this)}
            />
          )}
          {this.state.showSavedLocations && this.props.isDelivery && (
            <>
              <SavedLocations
                data={this.state.savedLocations}
                selectedLocation={this.state.selectedLocation}
                onChangeOutlet={this.onLocationSelect.bind(this)}
                locationSettings={this.props.locationSettings}
                onEditLocation={this.onEditLocation.bind(this)}
                onDeleteLocation={this.onDeleteLocation.bind(this)}
              />
              <div className="ps-3 pe-3" id="order_time">
                <div className="time-field mb-3 cursor">
                  <div className="f2">
                    <span
                      className="ps-2 cursor branding-btn-color"
                      onClick={this.onNewLocation.bind(this)}
                    >
                      <FontAwesomeIcon icon={faPlus} /> &nbsp;Add new Location
                    </span>
                  </div>
                </div>
              </div>
            </>
          )}
          {!this.state.showOutlets && !this.props.isDelivery && (
            <>
              <div
                className="card flex-md-row mb-2 box-shadow h-md-250 p-1 m-3 pt-3 pref-cell-border card-color"
                onClick={this.toggleSelectOutlet.bind(this)}
              >
                <div className="row row-width">
                  <div className="col-lg-12 order-types " id="order_type_id">
                    <div className="ps-3 pe-3" id="order_time">
                      <div className="time-field mb-3">
                        <div className="f3 text-bold card-font-color">
                          <span>
                            <FontAwesomeIcon icon={faBuilding} /> {this.state.selectedOutlet?.name}
                          </span>
                          <br></br>
                          <small>
                            <span className="fw-normal">
                              {this.state.selectedOutlet?.formattedAddress}
                            </span>
                          </small>
                        </div>
                        <div className="action mt-2">
                          <button className="btn btn-link p-0 highlight-color">
                            <FontAwesomeIcon icon={faCheckCircle} size={'lg'} />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <OrderTime
                order_type_id={this.props.order_type_id}
                orderTypes={this.props.location.orderTypes}
                workingHours={this.state.selectedOutlet.workingHours}
                timeSettings={timeSettings}
                eventWorkingHours={this.state.selectedOutlet.SpecialEvents}
                onChange={this.onChange.bind(this)}
                order_time={this.state.order_time}
                order_date={this.state.order_date}
                isPickUpNow={this.state.isPickUpNow}
                location={this.props.location}
                isDelivery={this.props.isDelivery}
                locationSettings={this.props.locationSettings}
              />
            </>
          )}
          {((this.state.savedLocations && this.state.savedLocations.length > 0) ||
            showLoginOption) &&
            !this.state.showOutlets &&
            !this.state.showSavedLocations &&
            this.props.isDelivery ? (
            <>
              {
                <>
                  {this.state.savedLocations && this.state.savedLocations.length > 0 ? (
                    <div className="card flex-md-row mb-2 box-shadow h-md-250 p-1 m-3 pt-3 pref-cell-border card-color">
                      <div className="row row-width">
                        <div className="col-lg-12 order-types " id="order_type_id">
                          <div className="ps-2 pe-3" id="order_time">
                            <div className="time-field mb-3">
                              <div className="f3 fw-bold card-font-color">
                                <span className="ps-2">
                                  <FontAwesomeIcon icon={faHome} />{' '}
                                  {this.state.selectedLocation?.name}
                                </span>
                                <br />
                                <small>
                                  <span className="ps-2 fw-normal">
                                    {this.state.selectedLocation?.address}
                                  </span>
                                </small>
                              </div>
                              <div className="action mt-2">
                                <button className="btn btn-link p-0 highlight-color">
                                  <FontAwesomeIcon icon={faCheckCircle} size={'lg'} />
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="f3 pb-3 m-3 px-2">
                      <a
                        href='#/'
                        className="cursor font-color-primary text-bold p-0 highlight-color"
                        onClick={this.props.toggleLoginModal}
                      >
                        <u>Login</u>
                      </a>{' '}
                      now to retrieve your saved locations
                    </div>
                  )}
                  <>
                    <div className="ps-3 pe-3" id="order_time">
                      <div className="time-field mb-3">
                        <div className="f3 fw-bold mt-1">
                          <span className="ps-2 primary-font-color fw-bold">Selected Outlet</span>
                        </div>
                        <div className="action">
                          {!this.state.showOutlets && this.props.isDelivery && (
                            <button
                              className="btn btn-link p-0 branding-btn-color"
                              onClick={this.toggleSelectOutlet.bind(this)}
                            >
                              Change
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                    <div
                      className="card flex-md-row mb-2 box-shadow h-md-250 p-1 m-3 pt-3 pref-cell-border card-color"
                      onClick={
                        this.state.deliveryOutletError
                          ? this.toggleSelectOutlet.bind(this)
                          : console.log
                      }
                    >
                      <div className="row row-width">
                        <div className="col-lg-12 order-types" id="order_type_id">
                          <div className="ps-2 pe-3" id="order_time">
                            <div className="time-field mb-3">
                              <div className="f3 fw-bold card-font-color">
                                <span className="ps-2">
                                  <FontAwesomeIcon icon={faBuilding} />{' '}
                                  {this.state.selectedOutlet?.name}
                                </span>
                                <br></br>
                                {/* <small> */}
                                <div
                                  className={`ps-2 fw-normal ${this.state.deliveryOutletError
                                    ? 'card-error-color'
                                    : 'font-color-black'
                                    }`}
                                >
                                  {this.state.deliveryOutletError
                                    ? "This outlet doesn't deliver to this address. Tap to find a closer outlet"
                                    : this.state.selectedOutlet?.formattedAddress}
                                </div>
                                {/* </small> */}
                              </div>
                              <div className="action mt-2">
                                <button
                                  className={`btn btn-link p-0 ${this.state.deliveryOutletError
                                    ? 'card-error-color'
                                    : 'highlight-color'
                                    }`}
                                >
                                  <FontAwesomeIcon
                                    size={'lg'}
                                    icon={
                                      this.state.deliveryOutletError ? faTimesCircle : faCheckCircle
                                    }
                                  />
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                  <OrderTime
                    order_type_id={this.props.order_type_id}
                    orderTypes={this.props.location.orderTypes}
                    workingHours={this.state.selectedOutlet.workingHours}
                    timeSettings={timeSettings}
                    eventWorkingHours={this.state.selectedOutlet.SpecialEvents}
                    onChange={this.onChange.bind(this)}
                    order_time={this.state.order_time}
                    order_date={this.state.order_date}
                    isPickUpNow={this.state.isPickUpNow}
                    location={this.props.location}
                    isDelivery={this.props.isDelivery}
                    locationSettings={this.props.locationSettings}
                  />
                </>
              }
            </>
          ) : (
            ''
          )}
        </>
      );
    } else if (grid_layout !== 'old') {
      return (
        <>
          {this.state.loaded && this.state.showOutlets && (
            <MapModal
              toggleModal={this.toggleMapModal.bind(this)}
              showModal={this.state.showMapModal}
              name="Search Outlet"
              isTakeAway={true}
              data={this.props.outlets}
              selectedOutlet={this.state.selectedOutlet}
              locationSettings={this.props.locationSettings}
              onChangeOutlet={this.onChangeOutlet.bind(this)}
            />
          )}
          {this.state.loaded && this.props.isDelivery && !this.state.showOutlets && (
            <MapModal
              toggleModal={this.toggleMapModal.bind(this)}
              showModal={this.state.showMapModal}
              name="Add new location"
              itemIndex={this.state.itemIndex}
              editLocation={this.state.editLocation}
              data={this.props.outlets}
              selectedOutlet={this.state.selectedOutlet}
              locationSettings={this.props.locationSettings}
              updateSavedLocations={this.updateSavedLocations.bind(this)}
            />
          )}

          {this.state.loaded && (
            <AlertModal
              toggleModal={this.toggleAlertModal.bind(this)}
              locationSettings={this.props.locationSettings}
              showModal={this.state.showAlerModal}
              msg="Are you sure to delete this location?"
              deleteLocation={this.deleteLocation.bind(this)}
            />
          )}

          {this.state.loaded && (
            <TimePickerModal
              {...this.state}
              onChange={this.onChange.bind(this)}
              toggleModal={this.toggleTimePickerModal.bind(this)}
              showModal={this.state.showTimePickerModal}
              locationSettings={this.props.locationSettings}
              orderTypes={this.props.location.orderTypes}
              isDelivery={this.props.isDelivery}
              workingHours={this.state.selectedOutlet.workingHours}
            />
          )}
          <div className="ps-3 pe-3" id="order_time">
            <div className="time-field mb-2">
              <div className="f3 text-bold mt-1">
                {((showLoginOption && this.props.isDelivery) ||
                  (this.state.savedLocations &&
                    this.state.savedLocations.length > 0 &&
                    this.props.isDelivery &&
                    !this.state.showOutlets)) && (
                    <span className="ps-2 fw-bold primary-font-color">
                      {this.state.showSavedLocations ? 'Saved Locations' : 'Selected Location'}
                    </span>
                  )}
                {((this.props.outlets && !this.props.isDelivery) ||
                  (this.state.showOutlets && !this.state.showSavedLocations)) && (
                    <span className="ps-2 cursor primary-font-color" onClick={this.toggleSelectOutlet.bind(this)}>
                      Select Outlet
                    </span>
                  )}
                {!showLoginOption &&
                  this.props.isDelivery &&
                  !this.state.showSavedLocations &&
                  (!this.state.savedLocations || this.state.savedLocations.length === 0) && (
                    <span
                      className="ps-2 cursor primary-font-color"
                      onClick={this.onNewLocation.bind(this)}
                    >
                      <FontAwesomeIcon icon={faPlus} /> &nbsp;Add new Location
                    </span>
                  )}
              </div>
              <div className="mt-1 f3 d-flex flex-auto justify-content-between">
                {this.state.showOutlets &&
                  (!this.props.isDelivery || !this.state.showSavedLocations) && (
                    <>
                      <span
                        className="ps-2 cursor ml-1 branding-btn-color text-des"
                        onClick={this.toggleMapModal.bind(this)}
                      >
                        Show Map
                      </span>
                      <span
                        className="ps-2 cursor branding-btn-color"
                        onClick={this.toggleSelectOutlet.bind(this)}
                      >
                        Back
                      </span>
                    </>
                  )}
                {!this.state.showOutlets && !this.props.isDelivery && (
                  <>
                    <div></div>
                    <button
                      className="btn btn-link p-0 branding-btn-color"
                      onClick={this.toggleSelectOutlet.bind(this)}
                    >
                      Change
                    </button>
                  </>
                )}
                {this.props.isDelivery &&
                  this.state.savedLocations &&
                  !this.state.showOutlets &&
                  !(
                    !showLoginOption &&
                    this.props.isDelivery &&
                    (!this.state.savedLocations || this.state.savedLocations.length === 0)
                  ) && (
                    <>
                      <div></div>
                      <button
                        className="btn btn-link p-0 branding-btn-color"
                        onClick={this.toggleSavedLocations.bind(this)}
                      >
                        {this.state.showSavedLocations ? 'Back' : 'Edit'}
                      </button>
                    </>
                  )}
              </div>
            </div>
          </div>
          {this.state.showOutlets && (
            <Outlets
              data={this.props.outlets}
              geoLocation={this.props.geoLocation}
              showOutlets={this.state.showOutlets}
              onChangeOutlet={this.onChangeOutlet.bind(this)}
            />
          )}
          {this.state.showSavedLocations && this.props.isDelivery && (
            <>
              <SavedLocations
                data={this.state.savedLocations}
                selectedLocation={this.state.selectedLocation}
                onChangeOutlet={this.onLocationSelect.bind(this)}
                locationSettings={this.props.locationSettings}
                onEditLocation={this.onEditLocation.bind(this)}
                onDeleteLocation={this.onDeleteLocation.bind(this)}
              />
              <div className="ps-3 pe-3" id="order_time">
                <div className="time-field mb-3 cursor">
                  <div className="f2">
                    <span
                      className="ps-2 type-title primary-font-color cursor"
                      onClick={this.onNewLocation.bind(this)}
                    >
                      <FontAwesomeIcon icon={faPlus} color='var(--primary-font-color)' /> &nbsp;Add new Location
                    </span>
                  </div>
                </div>
              </div>
            </>
          )}
          {!this.state.showOutlets && !this.props.isDelivery && (
            <>
              <div
                className={`card card-custom flex-md-row mb-2 box-shadow h-md-250 p-3 m-3 pt-3 pref-cell-border card-color ${card_outline}`}
                onClick={this.toggleSelectOutlet.bind(this)}
              >
                <div className="row row-width">
                  <div className="col-lg-12 order-types " id="order_type_id">
                    <div className="ps-3 pe-3" id="order_time">
                      <div className="time-field mb-3">
                        <div className="f3 text-bold">
                          <span className="ps-2 type-title card-font-color">
                            <FontAwesomeIcon icon={faBuilding} color='var(--card-font-color)' /> {this.state.selectedOutlet?.name}
                          </span>
                          <br></br>
                          <small>
                            <span className="working-hour card-font-color d-inline-block fw-light">
                              {this.state.selectedOutlet?.formattedAddress}
                            </span>
                          </small>
                        </div>
                        <div className="action mt-2">
                          <button className="btn btn-link p-0 highlight-color">
                            <FontAwesomeIcon icon={faCheckCircle} size={'lg'} />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <OrderTime
                order_type_id={this.props.order_type_id}
                orderTypes={this.props.location.orderTypes}
                workingHours={this.state.selectedOutlet.workingHours}
                timeSettings={timeSettings}
                locationSettings={this.props.locationSettings}
                eventWorkingHours={this.state.selectedOutlet.SpecialEvents}
                onChange={this.onChange.bind(this)}
                order_time={this.state.order_time}
                order_date={this.state.order_date}
                isPickUpNow={this.state.isPickUpNow}
                isDelivery={this.props.isDelivery}
                location={this.props.location}
              />
            </>
          )}
          {((this.state.savedLocations && this.state.savedLocations.length > 0) ||
            showLoginOption) &&
            !this.state.showOutlets &&
            !this.state.showSavedLocations &&
            this.props.isDelivery ? (
            <>
              {
                <>
                  {this.state.savedLocations && this.state.savedLocations.length > 0 ? (
                    <div className={`card card-custom flex-md-row mb-2 box-shadow h-md-250 p-3 m-3 pt-3 pref-cell-border card-color ${card_outline}`}>
                      <div className="row row-width">
                        <div className="col-lg-12 order-types " id="order_type_id">
                          <div className="ps-3 pe-3" id="order_time">
                            <div className="time-field mb-3">
                              <div className="f3 text-bold">
                                <span className="ps-2 type-title card-font-color">
                                  <FontAwesomeIcon icon={faHome} color='var(--card-font-color)' />
                                  {this.state.selectedLocation?.name}
                                </span>
                                <br />
                                <small>
                                  <span className="working-hour card-font-color d-inline-block fw-light">
                                    {this.state.selectedLocation?.address}
                                  </span>
                                </small>
                              </div>
                              <div className="action mt-2">
                                <button className="btn btn-link p-0 highlight-color">
                                  <FontAwesomeIcon icon={faCheckCircle} size={'lg'} />
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="ps-2 f3 pb-3 m-3 primary-font-color">
                      <a
                        href='#/'
                        className="cursor font-color-primary text-bold p-0 highlight-color"
                        onClick={this.props.toggleLoginModal}
                      >
                        <u>Login</u>
                      </a>{' '}
                      now to retrieve your saved locations
                    </div>
                  )}
                  <>
                    <div className="ps-3 pe-3" id="order_time">
                      <div className="time-field mb-3">
                        <div className="f3 text-bold mt-1">
                          <span className="ps-2 primary-font-color fw-bold">Selected Outlet</span>
                        </div>
                        <div className="action">
                          {!this.state.showOutlets && this.props.isDelivery && (
                            <button
                              className="btn btn-link p-0 branding-btn-color"
                              onClick={this.toggleSelectOutlet.bind(this)}
                            >
                              Change
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                    <div
                      className={`card card-custom flex-md-row mb-2 box-shadow h-md-250 p-3 m-3 pt-3 pref-cell-border card-color ${card_outline}`}
                      onClick={
                        this.state.deliveryOutletError
                          ? this.toggleSelectOutlet.bind(this)
                          : console.log
                      }
                    >
                      <div className="row row-width">
                        <div className="col-lg-12 order-types" id="order_type_id">
                          <div className="ps-3 pe-3" id="order_time">
                            <div className="time-field mb-3">
                              <div className="f3 text-bold">
                                <span className="ps-2 type-title card-font-color">
                                  <FontAwesomeIcon icon={faBuilding} color='var(--card-font-color)' />{' '}
                                  {this.state.selectedOutlet?.name}
                                </span>
                                <br></br>
                                <small>
                                  <span
                                    className={`working-hour ${this.state.deliveryOutletError
                                      ? 'card-error-color'
                                      : 'card-font-color'
                                      }`}
                                  >
                                    {this.state.deliveryOutletError
                                      ? "This outlet doesn't deliver to this address. Tap to find a closer outlet"
                                      : this.state.selectedOutlet?.formattedAddress}
                                  </span>
                                </small>
                              </div>
                              <div className="action mt-2">
                                <button
                                  className={`btn btn-link p-0 ${this.state.deliveryOutletError
                                    ? 'text-danger'
                                    : 'highlight-color'
                                    }`}
                                >
                                  <FontAwesomeIcon
                                    size={'lg'}
                                    icon={
                                      this.state.deliveryOutletError ? faTimesCircle : faCheckCircle
                                    }
                                  />
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                  <OrderTime
                    order_type_id={this.props.order_type_id}
                    orderTypes={this.props.location.orderTypes}
                    workingHours={this.state.selectedOutlet.workingHours}
                    timeSettings={timeSettings}
                    locationSettings={this.props.locationSettings}
                    eventWorkingHours={this.state.selectedOutlet.SpecialEvents}
                    onChange={this.onChange.bind(this)}
                    order_time={this.state.order_time}
                    order_date={this.state.order_date}
                    isPickUpNow={this.state.isPickUpNow}
                    isDelivery={this.props.isDelivery}
                    location={this.props.location}
                  />
                </>
              }
            </>
          ) : (
            ''
          )}
        </>
      );
    }
  }
}

export default OrderTypeDetails;
